export const ClaudeModels = ['claude-sonnet-4-20250514'] as const;
export const GPTModels = ['gpt-5-nano', 'gpt-5', 'gpt-4.1-mini'] as const;
const AIModels = [...ClaudeModels, ...GPTModels] as const;
export const defaultAIModel: AIModel = 'claude-sonnet-4-20250514';
export type ClaudeModel = (typeof ClaudeModels)[number];
export type GPTModel = (typeof GPTModels)[number];
export type AIModel = (typeof AIModels)[number];

export type Provider = 'openai' | 'anthropic';

export function providerFromModel(aIModel: AIModel): Provider {
    return ClaudeModels.includes(aIModel as any) ? 'anthropic' : 'openai';
}

